function closeNavButton() {
  var togglers = jQuery(".navbar-toggler");
  var smnav = jQuery(".smnav");
  var offcanvas = jQuery(".offcanvas");

  // Toggle active class on SVG when toggler is clicked
  togglers.on("click", function () {
    var svg = jQuery(this).find(".smnav");
    svg.toggleClass("active");

    if (svg.hasClass("active")) {
      smnav.addClass("active");
    } else {
      smnav.removeClass("active");
    }
  });

  // Close menu when clicking outside
  jQuery(document).on("click", function (e) {
    if (
      !togglers.is(e.target) &&
      togglers.has(e.target).length === 0 &&
      offcanvas.has(e.target).length === 0
    ) {
      togglers.find(".smnav").removeClass("active");
      smnav.removeClass("active");
      offcanvas.offcanvas("hide");
    }
  });

  // ✅ Close menu and handle smooth scroll for anchor links
  offcanvas.find("a").on("click", function (e) {
    var href = jQuery(this).attr("href");

    // Skip empty links
    if (!href) return;

    // Extract the hash part (e.g. from "/#about" → "#about")
    var hashIndex = href.indexOf("#");
    var hash = hashIndex !== -1 ? href.substring(hashIndex) : null;

    // If there's a hash (same-page anchor)
    if (hash) {
      var target = jQuery(hash);

      // Prevent default behavior if the anchor exists on this page
      if (target.length) {
        e.preventDefault();

        jQuery("html, body").animate(
          {
            scrollTop: target.offset().top,
          },
          600
        );
      }
    }

    // Close menu regardless
    togglers.find(".smnav").removeClass("active");
    smnav.removeClass("active");
    offcanvas.offcanvas("hide");
  });
}

closeNavButton();

function newsSlider() {
  var swiper = new Swiper(".news-slider", {
    slidesPerView: 1.25,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.25,
      },
      991: {
        slidesPerView: 3,
      },
    },
  });
}
newsSlider();

function videoSlider() {
  var swiper = new Swiper(".videoSlider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // We use 'slideChangeTransitionStart' to stop the video immediately
  // before the slide transition animation begins.
  swiper.on("slideChangeTransitionStart", function () {
    // Get the previous slide's DOM element (the one we are moving away from)
    const previousSlide = swiper.slides[swiper.previousIndex];

    // Safety check: ensure the element exists
    if (previousSlide) {
      // Find all iframe elements within the slide (these hold the videos)
      const videoIframes = previousSlide.querySelectorAll("iframe");

      // Loop through each found iframe
      videoIframes.forEach((iframe) => {
        // Get the current source URL
        const currentSrc = iframe.src;

        // Check if the src is not empty (ensures it's a valid iframe)
        if (currentSrc) {
          // The trick: Setting the 'src' attribute to its current value
          // forces the iframe to reload its content, which stops the video playback.
          iframe.src = currentSrc;
        }
      });
    }
  });
}
// Call the function to initialize the slider when the script loads
videoSlider();

function testimonialSlider() {
  var swiper = new Swiper(".testimonialSlider", {
    cssMode: true,
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    mousewheel: true,
    keyboard: true,
  });
}
testimonialSlider();

function heroImageSlider() {
  var swiper = new Swiper(".imageSlider-text", {
    cssMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
    },
    mousewheel: true,
    keyboard: true,
  });
}
heroImageSlider();

function menuScroll() {
  var prevScrollpos = jQuery(window).scrollTop();

  jQuery(window).on("scroll", function () {
    var currentScrollPos = jQuery(window).scrollTop();
    var $nav = jQuery("#main-nav");
    var isDesktop = jQuery(window).width() > 767;
    var hideTop = isDesktop ? "-176px" : "-160px";

    if (currentScrollPos <= 200) {
      // Above threshold: show nav with transparent background
      $nav
        .css({
          top: "0",
          background: "transparent",
        })
        .removeClass("scrolling");
    } else {
      if (prevScrollpos > currentScrollPos) {
        // Scrolling up past 200: show nav with dark background
        $nav
          .css({
            top: "0",
            background: "#38332D",
          })
          .addClass("scrolling");
      } else {
        // Scrolling down past 200: hide nav and keep dark background
        $nav.css({
          top: hideTop,
          background: "#38332D",
        });
      }
    }

    prevScrollpos = currentScrollPos;
  });
}
menuScroll();
